export default function DocsPage() {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 50 }}>
      <iframe
        src="/api-docs.html"
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="LinkFlow API Reference"
      />
    </div>
  );
}
